
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { InvestmentOpportunity } from "@/types/investment";
import ImageUpload from "../ImageUpload";
import CustomerSelectionField from "./CustomerSelectionField";

interface BasicInformationFieldsProps {
  formData: InvestmentOpportunity;
  onInputChange: (field: keyof InvestmentOpportunity, value: any) => void;
}

const BasicInformationFields = ({ formData, onInputChange }: BasicInformationFieldsProps) => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold text-gray-900">Basic Information</h3>
      
      <CustomerSelectionField
        value={formData.customer_id}
        onChange={(customerId) => onInputChange('customer_id', customerId)}
      />
      
      <div className="space-y-2">
        <Label htmlFor="title">Title *</Label>
        <Input
          id="title"
          value={formData.title}
          onChange={(e) => onInputChange('title', e.target.value)}
          placeholder="e.g., Land Contract - 123 Main St"
          required
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="property_address">Property Address</Label>
        <Input
          id="property_address"
          value={formData.property_address || ''}
          onChange={(e) => onInputChange('property_address', e.target.value)}
          placeholder="123 Main Street, City, State ZIP"
        />
      </div>

      <ImageUpload
        value={formData.thumbnail_image || ''}
        onChange={(url) => onInputChange('thumbnail_image', url)}
        label="Property Photo"
      />

      <div className="space-y-2">
        <Label htmlFor="description">Description</Label>
        <Textarea
          id="description"
          value={formData.description || ''}
          onChange={(e) => onInputChange('description', e.target.value)}
          placeholder="Brief description of the investment opportunity"
          rows={3}
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="collateral_details">Collateral Details</Label>
        <Textarea
          id="collateral_details"
          value={formData.collateral_details || ''}
          onChange={(e) => onInputChange('collateral_details', e.target.value)}
          placeholder="Details about the property securing this investment"
          rows={3}
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="status">Status</Label>
        <Select 
          value={formData.status} 
          onValueChange={(value) => onInputChange('status', value)}
        >
          <SelectTrigger>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="Available">Available</SelectItem>
            <SelectItem value="Under Review">Under Review</SelectItem>
            <SelectItem value="Sold">Sold</SelectItem>
            <SelectItem value="Withdrawn">Withdrawn</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};

export default BasicInformationFields;
